import { AdditionalInformationValueType } from '@bpos';
import { BetDetailType } from '@bpos/common/bet-placement';
import { Bet, Pick } from '@bpos/v2/bet-placement';
import { OfferSource } from '@cds';
import { isV2CompoundId } from '@frontend/sports/betting-offer/feature/model';

import { BetslipBetBuilderPick } from '../../../../../core/picks/betslip-bet-builder-pick';
import { ISlipPick } from '../../../../bet-generation/models';
import { BasePickRequestMapper } from './base-pick-request-mapper';
import { mapTextValueData } from './text-value-helper';

export class BetBuilderPickRequestMapper extends BasePickRequestMapper {
    mapBetDetails(slipPick: ISlipPick, bet: Bet): void {
        bet.picks = [{ id: slipPick.priceIds[0].toString(10) }] as Pick[];
        const pick = slipPick.pick as BetslipBetBuilderPick;
        const isTv2BetBuilder = pick.event.source === OfferSource.V2 || isV2CompoundId(pick.event.event.id);

        bet.betDetails.push({
            id: pick.sportId.toString(10),
            betDetailType: BetDetailType.Sport,
            additionalInformation: { informationItems: [] },
            ...mapTextValueData(pick, 'sportName'),
        });

        // Region
        bet.betDetails.push({
            id: pick.event.region.id.toString(10),
            betDetailType: BetDetailType.Region,
            additionalInformation: { informationItems: [] },
            ...mapTextValueData(pick, 'regionName'),
        });

        let id: string;
        if (isTv2BetBuilder) {
            id = pick.fixture.league ? pick.fixture.league.id.toString(10) : '';
        } else {
            id = pick.event.league.id.toString(10);
        }
        // League
        bet.betDetails.push({
            id,
            betDetailType: BetDetailType.Competition,
            additionalInformation: { informationItems: [] },
            ...mapTextValueData(pick, 'leagueName'),
        });

        // Event
        bet.betDetails.push({
            id: pick.fixture.fixtureId,
            betDetailType: BetDetailType.Fixture,
            additionalInformation: { informationItems: [] },
            ...mapTextValueData(pick, 'eventName'),
        });

        // Market
        bet.betDetails.push({
            id: pick.market.id.toString(10),
            betDetailType: BetDetailType.Market,
            additionalInformation: { informationItems: [] },
            ...mapTextValueData(pick, 'marketName'),
        });

        // Option
        bet.betDetails.push({
            id: pick.option.id.toString(10),
            betDetailType: BetDetailType.Option,
            additionalInformation: { informationItems: [] },
            ...mapTextValueData(pick, 'optionName'),
        });

        if (isTv2BetBuilder) {
            bet.additionalInformation.informationItems.push({
                key: 'isTv2BetBuilder',
                value: 'true',
                valueType: AdditionalInformationValueType.Boolean,
            });
        }

        if (!isTv2BetBuilder) {
            bet.additionalInformation.informationItems.push({
                key: 'betBuilderEventId',
                value: pick.event.event.id,
                valueType: AdditionalInformationValueType.Int32,
            });
        }

        bet.additionalInformation.informationItems.push({
            key: 'fixtureStartTime',
            value: pick.fixture.eventDate.toISOString(),
            valueType: AdditionalInformationValueType.DateTime,
        });

        bet.additionalInformation.informationItems.push({
            key: 'fixtureType',
            value: pick.fixture.fixtureType,
            valueType: AdditionalInformationValueType.Enum,
        });
    }
}
